import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import useAuth from '@hooks/useAuth';
import tricorService from '@services/tricorService';
import { useToasts } from 'react-toast-notifications';

export const BanksContext = React.createContext();

const BANKS_ERROR_MSG =
  'Estimado cliente, en estos momentos estamos con dificultades al cargar sus datos, intente más tarde.';

BanksProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default function BanksProvider({ children }) {
  const [{ isAuthenticated }] = useAuth();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { addToast } = useToasts();

  useEffect(() => {
    if (!isAuthenticated) {
      setBanks([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const fetchBanks = (attempt = 0) => {
      tricorService(98)
        .then((response) => {
          setBanks(response?.data?.banks || []);
          setLoading(false);
        })
        .catch((err) => {
          if (attempt === 0) {
            fetchBanks(1);
            return;
          }
          // eslint-disable-next-line no-console
          console.error('Error fetching banks (98):', err);
          setBanks([]);
          setError(err);
          setLoading(false);
          addToast(BANKS_ERROR_MSG, { appearance: 'error' });
        });
    };

    fetchBanks();
  }, [isAuthenticated, addToast]);

  const value = useMemo(
    () => ({ banks, loading, error }),
    [banks, loading, error]
  );

  return (
    <BanksContext.Provider value={value}>{children}</BanksContext.Provider>
  );
}
